/* Liten's Ocha-theme: vanilla JS, inga beroenden. */
(function () {
  "use strict";

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Header-skugga vid scroll */
  var header = document.querySelector("[data-site-header]");
  if (header) {
    var onScrollHeader = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 24);
    };
    onScrollHeader();
    window.addEventListener("scroll", onScrollHeader, { passive: true });
  }

  /* Mobilmeny */
  var burger = document.querySelector("[data-menu-toggle]");
  var mobileMenu = document.querySelector("[data-mobile-menu]");
  if (burger && mobileMenu) {
    var setMenu = function (open) {
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      mobileMenu.setAttribute("aria-hidden", open ? "false" : "true");
      mobileMenu.classList.toggle("is-open", open);
      document.body.classList.toggle("menu-open", open);
    };
    burger.addEventListener("click", function () {
      setMenu(burger.getAttribute("aria-expanded") !== "true");
    });
    mobileMenu.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        setMenu(false);
      });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") setMenu(false);
    });
  }

  /* Reveal vid inscroll */
  var revealEls = document.querySelectorAll("[data-reveal]");
  if (revealEls.length && "IntersectionObserver" in window && !reducedMotion) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px" }
    );
    revealEls.forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    revealEls.forEach(function (el) {
      el.classList.add("is-visible");
    });
  }

  /* Hero-parallax: loggan glider upp, fotot zoomar */
  var heroLogo = document.querySelector("[data-hero-logo]");
  var heroMedia = document.querySelector("[data-hero-media]");
  if ((heroLogo || heroMedia) && !reducedMotion) {
    var ticking = false;
    var onScrollHero = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY;
        var vh = window.innerHeight;
        var progress = Math.min(1, y / vh);
        if (heroLogo) {
          heroLogo.style.transform = "translateY(" + progress * -60 + "%)";
        }
        if (heroMedia) {
          heroMedia.style.transform = "scale(" + (1 + progress * 0.12) + ")";
        }
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScrollHero, { passive: true });
  }

  /* Fruktboll-story: scroll-progress på desktop, IntersectionObserver på mobil */
  var story = document.querySelector("[data-story]");
  if (story) {
    var steps = story.querySelectorAll("[data-story-step]");
    var rings = story.querySelectorAll("[data-story-ring]");
    var counter = story.querySelector("[data-story-counter]");
    var scrollWrap = story.querySelector("[data-story-scroll]");
    var counterTarget = counter
      ? parseInt(counter.getAttribute("data-target"), 10) || 56000000
      : 0;
    var counterDone = false;
    var currentIndex = -1;

    if (counter) {
      counter.textContent = counterTarget.toLocaleString("sv-SE");
    }

    var runCounter = function () {
      if (!counter || counterDone) return;
      counterDone = true;
      if (reducedMotion) {
        counter.textContent = counterTarget.toLocaleString("sv-SE");
        return;
      }
      var start = null;
      var duration = 1400;
      var tick = function (ts) {
        if (!start) start = ts;
        var pr = Math.min(1, (ts - start) / duration);
        counter.textContent = Math.round(counterTarget * pr).toLocaleString("sv-SE");
        if (pr < 1) window.requestAnimationFrame(tick);
      };
      window.requestAnimationFrame(tick);
    };

    var chipGroups = story.querySelectorAll("[data-story-chips]");

    var setActive = function (index) {
      if (index === currentIndex) return;
      currentIndex = index;
      steps.forEach(function (step, i) {
        step.classList.toggle("is-active", i === index);
      });
      rings.forEach(function (ring, i) {
        ring.classList.toggle("is-visible", i <= index);
      });
      chipGroups.forEach(function (group, i) {
        group.classList.toggle("is-visible", i === index);
      });
      var counterWrap = counter ? counter.parentElement : null;
      if (counterWrap) {
        counterWrap.classList.toggle("is-visible", index === steps.length - 1);
      }
      if (index === steps.length - 1) runCounter();
    };

    var isDesktop = window.matchMedia("(min-width: 1024px)");

    if (isDesktop.matches && scrollWrap && !reducedMotion) {
      story.classList.add("story--enhanced");
      var storyTicking = false;
      var onStoryScroll = function () {
        if (storyTicking) return;
        storyTicking = true;
        window.requestAnimationFrame(function () {
          var rect = scrollWrap.getBoundingClientRect();
          var range = rect.height - window.innerHeight;
          var progress = range > 0 ? Math.min(1, Math.max(0, -rect.top / range)) : 1;
          var index = Math.min(steps.length - 1, Math.floor(progress * steps.length));
          setActive(index);
          storyTicking = false;
        });
      };
      onStoryScroll();
      window.addEventListener("scroll", onStoryScroll, { passive: true });
    } else if ("IntersectionObserver" in window) {
      var stepObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              setActive(Array.prototype.indexOf.call(steps, entry.target));
            }
          });
        },
        { rootMargin: "-40% 0px -40% 0px" }
      );
      steps.forEach(function (step) {
        stepObserver.observe(step);
      });
      setActive(0);
    } else {
      setActive(steps.length - 1);
    }
  }

  /* PDP-galleri: thumbnail byter huvudbild */
  var mainImage = document.querySelector("[data-main-image]");
  if (mainImage) {
    document.querySelectorAll("[data-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        mainImage.src = thumb.dataset.full;
        mainImage.classList.toggle("is-transparent", thumb.dataset.transparent === "true");
        var thumbImg = thumb.querySelector("img");
        if (thumbImg) mainImage.alt = thumbImg.alt || mainImage.alt;
        document.querySelectorAll("[data-thumb]").forEach(function (t) {
          t.classList.toggle("is-active", t === thumb);
        });
      });
    });
  }

  /* Variantväljare: radio uppdaterar pris, hidden id och köpknapp */
  document.querySelectorAll("[data-product-form]").forEach(function (form) {
    var priceEl = form.closest("[data-product]")
      ? form.closest("[data-product]").querySelector("[data-product-price]")
      : null;
    var idInput = form.querySelector('input[name="id"]');
    form.querySelectorAll("[data-variant-radio]").forEach(function (radio) {
      radio.addEventListener("change", function () {
        if (idInput) idInput.value = radio.value;
        if (priceEl && radio.dataset.price) {
          priceEl.textContent = radio.dataset.price;
        }
      });
    });
  });
})();
